<template>
  <div>
    <div id="ai-message" class="relative flex flex-col bg-white mb-4 lg:flex-row justify-between items-justify lg:items-center rounded-xl border p-4 pt-3 md:p-6 md:pt-5 lg:p-4 lg:pt-3 xl:p-6 xl:pt-5 gap-4" v-if="this.changelogSuggestions == 'true' && this.showAiMessage == 'true' && this.subscriptionValid == 'true'">
      <div class="flex flex-col gap-1" style="max-width: 32rem;">
        <p class="font-bold text-neutral-800">{{ $t('FeedBear can help you write your changelog.') }}</p>
        <p class="text-neutral-800 text-sm">{{ $t('Use AI to quickly write changelog entries and save time.') }}</p>
      </div>
      <div class="flex flex-col sm:flex-row gap-2">
        <button class="btn-main text-md flex justify-center items-justify rounded-xl whitespace-nowrap px-2 xl:px-6" @click.prevent="suggestChangelog()">
          {{ $t('Try it now!') }}
        </button>
        <button class="text-neutral-700 text-sm px-4 py-2 rounded-xl" @click.prevent="closeAIMessage()">
          {{ $t('No thanks') }}
        </button>
      </div>
    </div>
    <ChangelogSuggestModal :show-suggestion-modal="this.showSuggestionModal && this.subscriptionValid == 'true'" @close-modal="closeModal()"/>
  </div>
</template>

<script>
import VueTrix from "vue-trix";
import EventBus from "event_bus";
import ChangelogSuggestModal from "./changelog_suggest_modal.vue"

export default {
  props: ["initial-content", "title", "show-ai-message", "subscription-valid", "show-suggestion-modal", "changelog-suggestions"],
  data: function () {
    return {
      editorContent: this.initialContent || "",
      titleContent: this.title || "",
      errors: { title: false, body: false },
      showSuggestionModal: this.showSuggestionModal,
      subscriptionValid: this.subscriptionValid,
      posts: [],
    };
  },
  components: { VueTrix, ChangelogSuggestModal },
  created() {
    EventBus.$on("errorChangelog", (errors) => {
      this.errors = errors;
    });
  },
  mounted() {
    EventBus.$emit("changelogTextAdded", {
      body: !!this.editorContent,
      title: !!this.titleContent,
    });
  },
  methods: {
    updateEditorContent(value) {
      EventBus.$emit("changelogTextAdded", {
        body: !!this.editorContent,
        title: !!this.titleContent,
      });
    },
    uploadFile(event) {
      let file = event.attachment.file;
      if (!file) return;
      // TODO: Check size, do not upload anything above 5MB

      let data = new FormData();
      data.append("image", file);

      Rails.ajax({
        url: "/updates/images",
        type: "POST",
        data: data,
        dataType: "json",
        beforeSend: function () {
          return true;
        },
        success: (data) => {
          console.log(data);
          console.log("Added Image");

          let attributes = {
            url: data.image_link,
            href: data.image_link,
            blob_id: data.image_id,
          };
          event.attachment.setAttributes(attributes);
        },
        error: (data, status) => {
          console.log(data);
        },
      });
    },
    destroyFile(event) {
      let blob_id = event.attachment.attachment.attributes.values.blob_id;

      Rails.ajax({
        url: "/updates/images/" + blob_id,
        type: "DELETE",
        beforeSend: function () {
          return true;
        },
        success: (data) => {
          console.log("Destroy Image");
          console.log(data);
        },
        error: (data, status) => {
          console.log("Destroy Image");
          console.log(data);
        },
      });
    },
    suggestChangelog(){
      this.showSuggestionModal = true;
    },
    closeAIMessage(){
      Rails.ajax({
        url: `/changelog/remove_ai_message`,
        type: "POST",
        dataType: "json",
        beforeSend: function () {
          return true;
        },
        success: (data) => {
          document.getElementById('ai-message').remove();
        },
        error: (data, status) => {
          console.log(data);
        },
      });
    },
    closeModal(){
      this.showSuggestionModal = false;
    }
  },
  watch: {
    editorContent: {
      handler: "updateEditorContent",
    },
    titleContent: {
      handler: "updateEditorContent",
    },
  },
};
</script>

<style>
trix-editor:empty:not(:focus)::before {
  color: #a9a9a9;
}

.error_show {
  color: red;
  margin-left: 2px;
}

.trix-content .attachment--preview .attachment__caption {
  margin-top: 12px;
}
</style>
